import * as React from 'react';
import '@notes/sticky-notes-layout/dist/LayoutSDK.global.css';
import { LayoutComponent } from '@notes/sticky-notes-layout';
import getNotesSDK from '../utils/getNotesSDK';
import MailListHeaderSecondRowTextContent from 'owa-mail-list-view/lib/components/listHeaders/MailListHeaderSecondRowTextContent';

const classNames = require('classnames');
const styles = require('./NotesPane.scss');

export interface NotesPaneProps {
    folderName: string;
}

// tslint:disable:prefer-functional-components
export default class NotesPane extends React.Component<NotesPaneProps, any> {
    render() {
        const header = (
            <MailListHeaderSecondRowTextContent
                text={this.props.folderName}
                containerCssClass={classNames(styles.notesHeader)}
            />
        );

        return <LayoutComponent sdk={getNotesSDK()} customHeaderContent={header} />;
    }
}
